import toast from 'react-hot-toast'
import {AxiosError} from 'axios'

type ApiErrorResponse = {
  message?: string
}

export const handleApiError = (error: AxiosError<ApiErrorResponse>, toastId: string): void => {
  if (error.response) {
    // The request was made and the server responded with a status code that falls out of the range of 2xx
    const message = error.response.data?.message || 'Server error occurred'
    toast.error(message, {id: toastId})
  } else if (error.request) {
    // The request was made but no response was received
    toast.error('No response from the server', {id: toastId})
  } else {
    // Something happened in setting up the request that triggered an Error
    toast.error('An unexpected error occurred', {id: toastId})
  }
}
